import React, { Component } from 'react';
import { bucketHover} from "../actions/wordActions";
import { connect } from "react-redux";
import {
  wordPlacedSuccess,
  wordPlacedFailure,
  allWordsPlaced,
  draggingWord
} from "../actions/wordActions";
import rimshot from "../badumtss.mp3";
import { isCorrectMatch } from "../utils/wordMatching";
import { BUCKET_HOVER_COLOR, BUCKET_MISS_HOVER_COLOR, CORRECT_DROP_COLOR, CORRECT_WORD_TEXT_COLOR,
  INCORRECT_DROP_COLOR } from "../utils/dragColors";

class WordBucket extends Component {
	constructor(props) {
	    super(props);
  }
  lightUp(event){
    // marks this as a valid drop target - without this, the browser always
    // treats every native drag as rejected (regardless of what dragend does
    // afterward) and plays its own ghost-image snap-back-to-origin
    // animation, which is exactly what looked like the word "moving back"
    // after being placed
    event.preventDefault()
    if(isCorrectMatch(this.props.punchline_words, this.props.words_correct, this.props.dragged_word_number, this.props.word_order)){
      event.target.style.backgroundColor = CORRECT_DROP_COLOR;
    }
  	else if (!this.props.words_correct[this.props.word_order]){
      event.target.style.backgroundColor = INCORRECT_DROP_COLOR;
    }
  	const rect = event.target.getBoundingClientRect()
    const order_id = this.props.order
  	this.props.dispatch(bucketHover([rect.x,rect.y], Number(order_id.slice(order_id.indexOf('_')+1))))
  }
  unLightUp(event){
  	event.target.style.backgroundColor = BUCKET_HOVER_COLOR;
  }
  checkWordPlacement(event){
    if(isCorrectMatch(this.props.punchline_words, this.props.words_correct, this.props.dragged_word_number, this.props.word_order)){
      let moving_word = document.getElementById("visible_"+String(this.props.dragged_word_number));
      moving_word.style.visibility = "hidden";
      event.target.style.backgroundColor = BUCKET_MISS_HOVER_COLOR;
      this.props.dispatch(wordPlacedSuccess(this.props.word_order))
      let placed_word = document.getElementById("invisible_"+String(this.props.word_order))
      placed_word.style.color = CORRECT_WORD_TEXT_COLOR;
      placed_word.style.border = "";
      this.props.dispatch(allWordsPlaced())
      // this.props.solved won't reflect this placement until the next
      // render (props are still the pre-dispatch values here, even for
      // the last word) - the actual "you solved it" celebration sound is
      // handled separately in Layout, off the real post-render
      // transition, not here
      if (!this.props.mute){
        let sound = new Audio(rimshot);
        sound.play().catch(() => {});
      }
      event.target.ontransitionend = (word) => {
        word.target.style.transitionDuration = '2s'
        word.target.style.backgroundColor = BUCKET_HOVER_COLOR;
      }
      event.target.style.transitionDuration = '0.1s';
      return true
    }
    else if (!this.props.words_correct[this.props.word_order]){
      event.target.style.backgroundColor = INCORRECT_DROP_COLOR;
      event.target.ontransitionend = (word) => {
        word.target.style.transitionDuration = '5s'
        word.target.style.backgroundColor = BUCKET_HOVER_COLOR;
      }
      event.target.style.transitionDuration = '0.1s';
    }
  }
  //click-to-place: place the currently-selected word (if any) here. On a
  //match this behaves like a successful drop and clears the selection; on a
  //mismatch the selection is left in place so the user can try another bucket
  handle_click(event){
    if (this.props.dragged_word_number === -1 || Array.isArray(this.props.dragged_word_number)){
      return;
    }
    const matched = isCorrectMatch(this.props.punchline_words, this.props.words_correct, this.props.dragged_word_number, this.props.word_order);
    this.checkWordPlacement(event);
    if (matched){
      this.props.dispatch(draggingWord(-1));
    }
    else if (!this.props.words_correct[this.props.word_order]){
      // only a genuine text mismatch should mark this incorrect - a bucket
      // that's already correctly filled should be left alone
      this.props.dispatch(wordPlacedFailure(this.props.word_order));
    }
  }
  handle_key_down(event){
    if (event.key === 'Enter' || event.key === ' '){
      event.preventDefault();
      this.handle_click(event);
    }
  }
  render() {
    const filled = this.props.words_correct[this.props.word_order];
    return(
    	<div onDragOver={(event) => this.lightUp(event)}
             onDragLeave={(event) => this.unLightUp(event)}
             onClick={(event) => this.handle_click(event)}
             onKeyDown={(event) => this.handle_key_down(event)}
    		   className='Hidden-Word' id={this.props.order}
             role="button" tabIndex={0}
             aria-label={filled ? 'Blank filled with "' + this.props.word + '"' : 'Empty blank - select a word, then choose this'}
             style={{color: filled ? CORRECT_WORD_TEXT_COLOR : 'transparent' }}
             ref={ref => this.input = ref}>
             {this.props.word} </div>
    	)
  }
}
const mapStateToProps = state => ({
  dragged_word_number:state.wordReducer.dragged_word_number,
  words_correct:state.jokeReducer.words_correct,
  punchline_words: state.jokeReducer.punchline_words,
  solved: state.jokeReducer.solved,
  mute: state.jokeReducer.mute
})
export default connect(mapStateToProps)(WordBucket);
